import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Check } from "@air/next-icons";
import { Tooltip } from "@air/primitive-tooltip";
import { useAirModal } from "@air/provider-modal";
import { useCopyToClipboard } from "__barrel_optimize__?names=useCopyToClipboard!=!react-use";
import { ChilipiperModal } from "~/components/Modals/ChilipiperModal";
import { useIsAdminEnterpriseMember } from "~/hooks/useAdminEnterpriseMember";
import { useCurrentWorkspacePermissionsContext } from "~/providers/CurrentWorkspacePermissionsProvider";
import { canManageSubscription } from "~/utils/permissions/workspacePermissions";
export const BoardId = (param)=>{
    let { id } = param;
    const { isAdminEnterpriseMember } = useIsAdminEnterpriseMember();
    const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();
    const [showContactSalesModal] = useAirModal(ChilipiperModal);
    const [state, copyToClipboard] = useCopyToClipboard();
    const canEditPlan = canManageSubscription(workspacePermissions);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col items-start gap-1",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "text-12 font-medium text-grey-10",
                children: "Board ID"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex gap-1",
                children: isAdminEnterpriseMember ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Tooltip, {
                            label: "Copy to clipboard",
                            children: /*#__PURE__*/ _jsx("button", {
                                className: "select-all text-12 text-grey-9",
                                onClick: ()=>copyToClipboard(id),
                                children: id
                            })
                        }),
                        !!state.value && /*#__PURE__*/ _jsx(Check, {
                            className: "size-4 text-blue-9"
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs("div", {
                    className: "text-12 text-grey-9",
                    children: [
                        "Upgrade to Enterprise to access API info.",
                        " ",
                        canEditPlan ? /*#__PURE__*/ _jsx("button", {
                            className: "mr-1 inline text-grey-12 hover:underline",
                            onClick: ()=>showContactSalesModal({
                                    uiLocation: "asset_modal_api_cta"
                                }),
                            children: "Contact sales →"
                        }) : "Contact a workspace admin to upgrade."
                    ]
                })
            })
        ]
    });
};
